export default __webpack_public_path__ + "locales/pt-BR/InviteDialog.json?hash=d9ed4be9699396eb1b28b666f9e56d12";